import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Inventory from './inventory';
import InventoryUpdate from './inventory-update';
import DeviceDeleteDialog from './inventory-delete-dialog';
import DeviceDetail from '../device/device-detail';
import { useAppSelector } from 'app/config/store';
import { PERMISSIONS } from 'app/config/constants';
import { hasPermissions } from 'app/shared/auth/private-route';

const InventoryRoutes = () => {
  const permissions = useAppSelector(state => state.authentication.account.permissions);
  const isInventoryReadOnly = hasPermissions(permissions, [PERMISSIONS.INVENTORY_READ]);
  const isInventoryAddDevice = !hasPermissions(permissions, [PERMISSIONS.INVENTORY_ADD_DEVICE_EDIT, PERMISSIONS.ALL]);

  return (
    <ErrorBoundaryRoutes>
      <Route index element={<Inventory />} />
      <Route path="new" element={<InventoryUpdate isReadOnly={isInventoryAddDevice} />} />
      <Route path=":id">
        <Route index element={<DeviceDetail />} />
        <Route path="edit" element={<InventoryUpdate isReadOnly={isInventoryReadOnly} />} />
        <Route path="delete" element={<DeviceDeleteDialog />} />
      </Route>
    </ErrorBoundaryRoutes>
  );
};

export default InventoryRoutes;
